import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import { intlShape } from 'common/components/intl/intlShape';

import { translateMessage } from 'common/components/Intl';
import ApiClient from 'api/ApiClient';
import { translatedPurchaseLocations } from 'common/purchase_locations';

// Note: defaultPurchaseLocations are currently only being passed in by
// the storybook. Will look to remove this dependency in the near future.
const PurchaseLocationSelector = (
  { input: { value, onChange, defaultPurchaseLocations } },
  { intl }
) => {
  const [purchaseLocations, setPurchaseLocations] = useState(
    defaultPurchaseLocations || []
  );

  useEffect(() => {
    if (!purchaseLocations.length) {
      ApiClient.fetchStorePurchaseLocations()
        .then(handleSuccess)
        .catch(handleFailure);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSuccess = response => {
    setPurchaseLocations(
      translatedPurchaseLocations(intl, response['purchase_locations'])
    );
  };

  const handleFailure = () => setPurchaseLocations([]);

  const helpText = translateMessage(intl, 'common.purchase_location.help_text');

  return (
    <div className="purchase-location-selector__wrapper">
      <div className="intl-text">
        <Select
          searchable
          clearable={false}
          value={value}
          onChange={e => onChange(e.value)}
          options={purchaseLocations}
          placeholder={helpText}
        />
      </div>
    </div>
  );
};

PurchaseLocationSelector.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultPurchaseLocations: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
  }),
};

PurchaseLocationSelector.contextTypes = {
  intl: intlShape,
};

export default PurchaseLocationSelector;
